import { useCallback } from 'react';
import { useStoredFollowingCount } from '~/common/hooks/use-auth/use-stored-following-count';
import { useFollow } from '@app/_hooks/use-follow-unfollow';

export const useFollowUser = () => {
  const { update, isMutating, error } = useFollow();
  const { addFollowingCount } = useStoredFollowingCount();

  const followUser = useCallback(
    async (followAuthorId: string, followRequestedSeriesId?: string) => {
      return new Promise<void>((resolve, reject) => {
        if (!followAuthorId) {
          reject();
          return;
        }
        update({
          userId: followAuthorId,
          mutualFollowSeriesId: followRequestedSeriesId,
        }).then(() => {
          addFollowingCount();
          resolve();
        });
      });
    },
    [addFollowingCount, update]
  );

  return {
    followUser,
    submitting: isMutating,
    error: error,
  };
};
